import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';

import { AuthPagesSlider } from 'features/auth/components/AuthPagesSlider';

import { ReactComponent as LogoIcon } from 'assets/icons/logo-icon.svg';

import { useStyles } from './styles';

type AuthPageLayoutProps = {
  title: string;
  additionalContentClassName?: string;
  isSignUp?: boolean;
};

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children, title, additionalContentClassName }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="row"
      alignItems="center"
      className={classes.formLayoutWrapper}
    >
      <Box display="flex" flexDirection="column" className={clsx(classes.contentWrapper, additionalContentClassName)}>
        <Typography variant="h1" className={classes.title}>
          {title}
        </Typography>
        {children}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-evenly"
        alignSelf="center"
        height="100%"
        className={classes.sliderWrapper}
      >
        <Box display="flex" justifyContent="center" className={classes.sliderLogoWrapper}>
          <LogoIcon />
        </Box>
        <AuthPagesSlider />
      </Box>
    </Box>
  );
};
